import i18n from './i18next';

export default {
    host: `https://${window.location.host}/api`,
    site: `https://${window.location.host}`,
}